export default "__VITE_ASSET__nWn3P4ts__"